module.exports = __webpack_public_path__ + "static/media/brunch2.04346dfa.png";